import { FormationsGhostButton } from 'components/common/Buttons';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import { useState } from 'react';
import { formatSsn } from 'helpers/text-transformer';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '200px',
    alignItems: 'center',
  },
  securedTextField: {
    fontFamily: 'password',
  },
}));

interface TParams {
  value: string;
}

export const ReadOnlySSN = ({ value }: TParams) => {
  const classes = useStyles();
  const [visibility, setVisibility] = useState(false);

  if(!value){
    return (<span>N/A</span>)
  }

  return (
    <div className={classes.root}>
      <span>
        {visibility? formatSsn(value) : `***-**-${value.substring(5)}`}
      </span>
      <FormationsGhostButton
        rounded
        onClick={() => setVisibility(!visibility)}
        sx={{
          padding: 0,
        }}
      >
        {visibility ? <VisibilityOff />: <Visibility />}
      </FormationsGhostButton>
    </div>
  );
};
